module.exports = __webpack_public_path__ + "static/media/es.03ef2d03.svg";